module.exports = __webpack_public_path__ + "img/user_video.fc466279.svg";